"use strict";

var get = require('./applyComponentProperties/getValueOfKeyMatching');

function parseDesignName(params, options) {
  // some lp orders have this field
  if (params.lp_alt_design) {
    return params.lp_alt_design;
  } // custom signs have this field


  if (get(params, /design_choices/)) {
    return get(params, /design_choices/);
  }

  var designStyles = options.map(function (_ref) {
    var value = _ref.value;
    return value;
  });
  var design_names = designStyles.filter(function (style) {
    return params.name.match(style);
  });

  if (design_names.length === 1) {
    return design_names[0];
  }

  if (design_names.length === 0) {
    if (params.name.match(/reprints|ribbon|wax seals|vellum jackets/i)) {
      return '';
    }

    console.warn("Could not parse design name \"".concat(params.name, "\""));
  }

  if (design_names.length > 1) {
    console.warn("name: ".concat(params.name, " matched ").concat(design_names.join(' / ')));
    return design_names[0];
  }

  return params.name;
}

module.exports = parseDesignName;